import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import find from 'lodash.find';
import {RedirectWithParams} from 'epic-diesel-common';
// import {Button, Message, RedirectWithParams} from 'epic-diesel-common';
// import {buttonTypes, priority} from 'epic-diesel-common/src/constants';
import styles from './SignUp.pcss';
import set from 'lodash.set';
import Countries from 'epic-diesel-form/src/constants/Countries';

import {
    // UserInfoSection,
    // GuardianSection,
    VerifyEmailSection,
    SignUpSuccessSection,
    // LegalAcknowledgementSection,
    // SocialAccountsSection,
    SignUpHeaderSection
    // RegionAndLanguageSection,
    // EulaFormSection,
    //ContentAndInterestsSection,
    // LoadIndicator
} from '../../components';
// import root from 'window-or-global';
import FormsyForm from 'epic-diesel-form/src/components/external/FormsyForm';
import infulencerActions from '../../actions/influencer.actions';
import userActions from '../../actions/user.actions';
import {
    getConductAgreement,
    getAffiliateAgreement,
    getIsEulasLoading
} from '../../selectors/eula.selectors';
import eulaActions from '../../actions/eula.actions';

const validSocialLinks = ['twitch', 'facebook', 'vk'];

const mapStateToProps = state => ({
    userState: state.get('user').toJS(),
    influencerState: state.get('influencer').toJS(),
    messages: state.get('localization').get('messageProperties'),
    configState: state.get('config'),
    eulaState: getConductAgreement(state),
    agreementState: getAffiliateAgreement(state),
    isEulasLoading: getIsEulasLoading(state)
});

const mapDispatchToProps = dispatch => ({
    createInfulencerProfile: model => {
        dispatch(infulencerActions.createInfluencerProfile(model));
    },
    resendEmailVerification: () => {
        dispatch(infulencerActions.resendEmailVerification());
    },
    checkEmailVerification: () => {
        dispatch(userActions.checkEmailVerification());
    },
    getSocialLinks: () => {
        dispatch(infulencerActions.getSocialLinks());
    },
    getAffiliateAgreement: () => dispatch(eulaActions.getAffiliateAgreement()),
    getConductAgreement: () => dispatch(eulaActions.getConductAgreement())
});

class SignUp extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        userState: PropTypes.object,
        influencerState: PropTypes.object,
        createInfulencerProfile: PropTypes.func,
        resendEmailVerification: PropTypes.func,
        checkEmailVerification: PropTypes.func,
        getSocialLinks: PropTypes.func,
        eulaState: PropTypes.object,
        agreementState: PropTypes.object,
        configState: PropTypes.object,
        isEulasLoading: PropTypes.bool,
        getAffiliateAgreement: PropTypes.func,
        getConductAgreement: PropTypes.func
    };

    componentDidMount() {
        const {isLoggedIn} = this.props.userState;

        if (isLoggedIn) {
            this.props.getSocialLinks();

            this.props.getAffiliateAgreement();
            this.props.getConductAgreement();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {influencerState, userState} = nextProps;

        const form = {...this.state.form};

        if (influencerState && influencerState.socialChannels) {
            for (let i = 0; i < influencerState.socialChannels.length; i++) {
                if (
                    !form.channels.find(c => c.url === influencerState.socialChannels[i].socialLink)
                ) {
                    form.channels.push({
                        platform: influencerState.socialChannels[i].socialLinkType,
                        url: influencerState.socialChannels[i].socialLink
                    });
                }
            }
        }

        const {affiliateAccount} = influencerState;
        if (affiliateAccount) {
            form.content = affiliateAccount.contentTypes || form.content;
            form.interests = affiliateAccount.interests || form.interests;
            form.city = affiliateAccount.city || form.city;
            form.state = affiliateAccount.state || form.state;
            form.country = affiliateAccount.country || form.country;
            form.discordUserId = affiliateAccount.discordUserId || form.discordUserId;
            form.age18Acknowledgment = affiliateAccount.ageConfirmed || form.age18Acknowledgment;
        }

        const {accountInfo} = userState;
        if (accountInfo) {
            form.language = accountInfo.preferredLanguage;
            form.country = form.country ? form.country : accountInfo.country || 'US';
            form.phoneNumber = accountInfo.phoneNumber || form.phoneNumber;
            form.acceptMfa = accountInfo.tfaEnabled || form.acceptMfa;
        }

        this.setState({form});
    }

    constructor(props) {
        super(props);
        this.state = {
            showError: false,
            socialValidated: true,
            channelValidated: true,
            //contentValidated: true,
            form: {
                content: [],
                channels: [],
                interests: [],
                acceptMfa: false,
                age18Acknowledgment: false,
                guardianAcknowledgment: false,
                guardian: {
                    firstName: '',
                    lastName: '',
                    relationship: ''
                },
                eulaAccepted: false,
                guardianAccepted: false,
                agreementAccepted: false,
                country: null,
                state: '',
                city: '',
                eula: {},
                agreement: {},
                language: '',
                discordUserId: null,
                phoneNumber: '',
                socialAcknowledgment: false
            }
        };
    }

    processSocialLinks = () => {
        const updatedSocialLinks = [];

        const {socialLinks} = this.props.influencerState;

        for (let i = 0; i < validSocialLinks.length; i++) {
            const entry = socialLinks
                ? socialLinks.find(e => e.externalAuthIdType === validSocialLinks[i])
                : null;

            if (!entry) {
                updatedSocialLinks.push({
                    externalAuthIdType: validSocialLinks[i],
                    externalDisplayName: null
                });
            } else {
                updatedSocialLinks.push(entry);
            }
        }

        return updatedSocialLinks;
    };

    submitForm = () => {
        const {form} = this.state;
        let hasError = false;
        //const link = find(this.processSocialLinks(), itme => itme.externalDisplayName);
        // if (!link) {
        //     this.setState({
        //         socialValidated: false
        //     });
        //     if (form.channels.length === 0) {
        //         this.setState({
        //             channelValidated: false
        //         });
        //     }
        //     return;
        // }
        const newState = {};

        if (form.channels.length === 0) {
            newState.channelValidated = false;
            hasError = true;
        }
        if (!form.age18Acknowledgment && !form.guardianAcknowledgment) {
            hasError = true;
        }
        // if (!form.content || form.content.length === 0) {
        //     newState.contentValidated = false;
        //     hasError = true;
        // }

        newState.showError = hasError;

        if (hasError) {
            this.setState(newState);
            return;
        }

        const formCloned = JSON.parse(JSON.stringify(form));
        this.props.createInfulencerProfile(formCloned);
    };

    invalidSubmitForm = () => {
        const {form} = this.state;
        // const link = find(this.processSocialLinks(), itme => itme.externalDisplayName);
        // if (!link) {
        //     this.setState({
        //         socialValidated: false
        //     });
        // }
        let channelValidated = true;
        if (form.channels.length === 0) {
            channelValidated = false;
        }

        this.setState({
            channelValidated,
            showError: true
        });
        // if (!form.content || form.content.length === 0) {
        //     this.setState({
        //         contentValidated: false
        //     });
        // }
    };

    resendEmailVerification = () => {
        this.props.resendEmailVerification();
    };

    updateTwoFactorAuthentication = (name, value) => {
        const {form} = this.state;
        form.acceptMfa = value;
        this.setState({form});
    };

    onAddChannel = data => {
        const {form} = this.state;
        const isExist = find(form.channels, data);
        if (!isExist && data && data.url !== '') {
            form.channels.push(data);
            this.setState({form});
        }
        if (form.channels.length > 0) {
            this.setState({
                channelValidated: true
            });
        }
    };

    onRemoveChannel = index => {
        const {form} = this.state;
        form.channels.splice(index, 1);
        this.setState({form});
        if (form.channels.length === 0) {
            this.setState({
                channelValidated: false
            });
        }
    };

    updateEulaStatus = (name, checked) => {
        const form = {...this.state.form};
        const eula = {...this.state.form.eula};

        eula.key = this.props.eulaState.key;
        eula.version = this.props.eulaState.version;
        eula.locale = this.props.eulaState.locale;

        form.eulaAccepted = checked;
        form.eula = eula;

        this.setState({form});
    };

    updateAgreementStatus = (name, checked) => {
        const form = {...this.state.form};
        const agreement = {...this.state.form.agreement};

        agreement.key = this.props.agreementState.key;
        agreement.version = this.props.agreementState.version;
        agreement.locale = this.props.agreementState.locale;

        form.agreementAccepted = checked;
        form.agreement = agreement;

        this.setState({form});
    };

    updateGuardianStatus = (name, checked) => {
        const form = {...this.state.form};
        form.guardianAccepted = checked;
        this.setState({form});
    };

    updateAgeAcknowledgment = (name, value) => {
        const {form} = this.state;
        if (name === 'ageAcknowledgment') {
            form.age18Acknowledgment = value;
            form.guardianAcknowledgment = false;
        } else if (name === 'guardianAcknowledgment') {
            form.guardianAcknowledgment = value;
            form.age18Acknowledgment = false;
        }
        this.setState({
            form
        });
    };

    updateSocialAcknowledgment = (name, value) => {
        const {form} = this.state;
        form.socialAcknowledgment = value;
        this.setState({form});
    };

    updateContent = (name, value) => {
        const {form} = this.state;
        const index = form.content.indexOf(name);

        if (value) {
            // We are adding. If it's already there, no-op
            if (index < 0) {
                form.content.push(name);
            }
        } else if (index >= 0) {
            // we are removing. If not there, no-op
            form.content.splice(index, 1);
        }

        this.setState({form});
    };

    updateInterests = (name, value) => {
        const {form} = this.state;
        const index = form.interests.indexOf(name);

        if (value) {
            // We are adding. If it's already there, no-op
            if (index < 0) {
                form.interests.push(name);
            }
        } else if (index >= 0) {
            // we are removing. If not there, no-op
            form.interests.splice(index, 1);
        }

        this.setState({form});
    };

    trigger = (name, value) => {
        const {form} = this.state;
        if (name === 'foreignBank') {
            set(form, name, value === 'true');
        } else if (name === 'guardianFirstName') {
            form.guardian.firstName = value;
        } else if (name === 'guardianLastName') {
            form.guardian.lastName = value;
        } else if (name === 'guardianRelationship') {
            form.guardian.relationship = value;
        } else {
            set(form, name, value);
        }
        if (name === 'foreignTax') {
            // form.taxType = '';
            // form.taxId = '';
            form.foreignTax = value === 'true';
            form.country = form.foreignTax ? Countries.slice(1)[0].value : 'US';
        } else if (name === 'businessType') {
            // form.taxType = '';
            // form.taxId = '';
            if (!form.foreignTax) form.taxType = form.businessType === 'INDIVIDUAL' ? 'SSN' : 'EIN';
        } else if (name === 'taxType') {
            form.taxId = '';
        } else if (name === 'phoneNumber') {
            form.phoneNumber = value;
        }
        this.setState({form});
    };

    renderMainContent(userState, influencerState, configState, messages) {
        const {emailVerified, isLoggedIn} = userState.accountInfo;
        const {affiliateAccount} = influencerState;
        // const {getSocialLinks} = this.props;

        // If we're not even logged in, we need to go back to the main page
        if (!isLoggedIn) {
            return <RedirectWithParams to="/affiliate/overview" />;
        }

        // If we already have an affiliate account created, that means we shouldn't be here
        if (affiliateAccount) {
            if (
                affiliateAccount.status === 'ACTIVE' ||
                affiliateAccount.status === 'DISABLED' ||
                affiliateAccount.status === 'DELETED' ||
                affiliateAccount.status === 'REJECTED'
            ) {
                return <RedirectWithParams to="/affiliate/overview" />;
            } else if (affiliateAccount.status === 'PENDING') {
                const messagesJs = messages ? messages.toJS() : null;
                return (
                    <SignUpSuccessSection
                        confirmationCode={affiliateAccount.verificationCode}
                        messages={messagesJs}
                    />
                );
            }
        }

        if (!emailVerified) {
            return (
                <div className={styles.container}>
                    <FormsyForm submitForm={this.resendEmailVerification}>
                        <VerifyEmailSection
                            sectionData={this.props.userState.accountInfo}
                            influencerState={influencerState}
                            checkingVerification={this.props.userState.checkingVerification}
                            checkEmailVerification={this.props.checkEmailVerification}
                        />
                    </FormsyForm>
                </div>
            );
        }

        // Always return to home page
        return <RedirectWithParams to="/affiliate/overview" />;

        // const {form} = this.state;
        // const {formStatus} = influencerState;
        // const socialLinks = this.processSocialLinks();
        // const {accountManagementUrl} = configState.toJS();

        // // only enable the submit button once everything is loaded
        // const enableSubmit = !this.props.isEulasLoading;

        // return (
        //     <div className={styles.container}>
        //         <FormsyForm
        //             invalidSubmit={this.invalidSubmitForm}
        //             formStatus={formStatus}
        //             submitForm={this.submitForm}
        //             callbackDelay={2000}>
        //             <LoadIndicator
        //                 isLoading={
        //                     this.props.isEulasLoading ||
        //                     this.props.userState.loading ||
        //                     this.props.influencerState.loading
        //                 }
        //                 messages={messages}>
        //                 <LegalAcknowledgementSection
        //                     messages={messages}
        //                     age18Acknowledgment={this.state.form.age18Acknowledgment}
        //                     guardianAcknowledgment={this.state.form.guardianAcknowledgment}
        //                     updateAgeAcknowledgment={this.updateAgeAcknowledgment}
        //                 />
        //                 <div className={styles.line} />
        //                 {this.state.form.guardianAcknowledgment && (
        //                     <div>
        //                         <GuardianSection
        //                             messages={messages}
        //                             form={form.guardian}
        //                             trigger={this.trigger}
        //                         />
        //                         <div className={styles.line} />
        //                     </div>
        //                 )}
        //                 <SocialAccountsSection
        //                     guardian={this.state.form.guardianAcknowledgment}
        //                     messages={this.props.messages}
        //                     sectionData={{
        //                         socialLinks,
        //                         channels: this.state.form.channels,
        //                         phoneNumber: this.state.form.phoneNumber
        //                     }}
        //                     onRemoveChannel={this.onRemoveChannel}
        //                     onAddChannel={this.onAddChannel}
        //                     socialValidated={this.state.socialValidated}
        //                     channelValidated={this.state.channelValidated}
        //                     accountManagementUrl={accountManagementUrl}
        //                     onPhoneNumberChange={this.trigger}
        //                     getSocialLinks={getSocialLinks}
        //                     socialAcknowledgment={this.state.form.socialAcknowledgment}
        //                     updateSocialAcknowledgment={this.updateSocialAcknowledgment}
        //                 />
        //                 <div className={styles.line} />
        //                 <RegionAndLanguageSection
        //                     messages={messages}
        //                     form={form}
        //                     trigger={this.trigger}
        //                 />
        //                 <div className={styles.line} />
        //                 <UserInfoSection
        //                     messages={messages}
        //                     form={form}
        //                     sectionData={this.props.userState.accountInfo}
        //                     updateTwoFactorAuthentication={this.updateTwoFactorAuthentication}
        //                 />
        //                 <div className={styles.line} />
        //                 {/* <ContentAndInterestsSection
        //                     messages={messages}
        //                     content={form.content}
        //                     showContentError={!this.state.contentValidated}
        //                     updateContent={this.updateContent}
        //                     interests={form.interests}
        //                     updateInterests={this.updateInterests} />
        //                 <div className={styles.line} /> */}
        //                 <EulaFormSection
        //                     messages={this.props.messages}
        //                     guardianAccepted={this.state.form.guardianAccepted}
        //                     updateGuardianStatus={this.updateGuardianStatus}
        //                     guardianAcknowledgment={this.state.form.guardianAcknowledgment}
        //                     acceptedAgreement={this.state.form.agreementAccepted}
        //                     acceptedConduct={this.state.form.eulaAccepted}
        //                     updateConductStatus={this.updateEulaStatus}
        //                     updateAgreementStatus={this.updateAgreementStatus}
        //                     loading={false}
        //                     failedToFetch={false}
        //                 />
        //                 <div className={styles.line} />
        //                 <div className={styles.submitSection}>
        //                     {this.state.showError && (
        //                         <div className={styles.errorMessage}>
        //                             <Message code="epic.affiliate.signup.form.fill_required_fields" />
        //                         </div>
        //                     )}

        //                     <Button
        //                         priority={priority.SECONDARY}
        //                         to="overview"
        //                         isExternalUrl={false}>
        //                         <Message code="epic.affiliate.common.cancel" />
        //                     </Button>

        //                     <Button
        //                         priority={priority.PRIMARY}
        //                         type={buttonTypes.SUBMIT}
        //                         disabled={!enableSubmit}
        //                         theme="dark">
        //                         <Message code="epic.affiliate.common.submit" />
        //                     </Button>

        //                     <div className={styles.privacyPolicy}>
        //                         <a
        //                             href="https://epicgames.com/privacypolicy"
        //                             target="_blank"
        //                             rel="noopener noreferrer">
        //                             <Message code="epic.affiliate.common.privacyPolicy" />
        //                         </a>
        //                     </div>
        //                 </div>
        //             </LoadIndicator>
        //         </FormsyForm>
        //     </div>
        // );
    }

    render() {
        const {influencerState, userState, configState, messages} = this.props;

        return (
            <div>
                <SignUpHeaderSection />
                <div className={styles.content}>
                    {this.renderMainContent(userState, influencerState, configState, messages)}
                </div>
            </div>
        );
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SignUp);
